<ion-header>
	<ion-toolbar>
		<ion-buttons slot="start">
			<ion-button (click)="dismiss()">Close</ion-button>
		</ion-buttons>
		<ion-title mode="ios">Ask Flagger</ion-title>
	</ion-toolbar>
</ion-header>

<ion-content class="ask-flagger-content">
	<div class="ask-flagger-intro">
		<ion-icon name="flag-outline"></ion-icon>
		<div>
			<h2>{{ contextTitle }}</h2>
			<p>{{ intro }}</p>
		</div>
	</div>

	<div class="message-list">
		<div *ngIf="!hasAskedQuestion" class="suggested-questions">
			<div class="suggested-heading">Try asking</div>
			<div class="suggested-grid">
				<ion-button
					*ngFor="
						let suggestedQuestion of visibleSuggestedQuestions;
						trackBy: trackBySuggestion
					"
					fill="outline"
					size="small"
					(click)="askSuggestedQuestion(suggestedQuestion.question)"
					[disabled]="loading"
				>
					{{ suggestedQuestion.label }}
				</ion-button>
			</div>
			<ion-button
				*ngIf="!showAllSuggestions"
				class="show-more-button"
				fill="clear"
				size="small"
				(click)="showAllSuggestions = true"
			>
				Show more
			</ion-button>
		</div>

		<div
			*ngFor="let message of messages; trackBy: trackByMessage"
			class="message-row"
			[class.user-message]="message.role === 'user'"
			[class.assistant-message]="message.role === 'assistant'"
		>
			<div class="message-bubble">
				<div class="message-label">
					{{ message.role === "user" ? "You" : "Ask Flagger" }}
				</div>
				<div class="message-text">{{ message.content }}</div>

				<div *ngIf="message.sources?.length" class="source-list">
					<ion-button
						class="show-sources-button"
						fill="clear"
						size="small"
						(click)="toggleSources(message)"
					>
						{{ message.showSources ? "Hide sources" : "Show sources" }}
					</ion-button>

					<div *ngIf="message.showSources">
						<div class="source-heading">Documentation used</div>
						<ion-chip
							*ngFor="let source of message.sources; trackBy: trackBySource"
							outline="true"
						>
							<ion-label>{{ sourceTitle(source) }}</ion-label>
						</ion-chip>
					</div>
				</div>
			</div>
		</div>

		<div *ngIf="loading" class="message-row assistant-message">
			<div class="message-bubble loading-bubble">
				<ion-spinner name="dots"></ion-spinner>
				<span>Searching FlaggerAI Central documentation</span>
			</div>
		</div>
	</div>
</ion-content>

<ion-footer>
	<ion-toolbar>
		<div class="question-composer">
			<ion-textarea
				autoGrow="true"
				rows="1"
				[placeholder]="placeholder"
				[(ngModel)]="question"
				(keydown)="onQuestionKeydown($event)"
				[disabled]="loading"
			></ion-textarea>
			<ion-button
				(click)="ask()"
				[disabled]="loading || !question.trim()"
			>
				<ion-spinner *ngIf="loading" slot="start" name="dots"></ion-spinner>
				<ion-icon
					*ngIf="!loading"
					slot="start"
					name="send-outline"
				></ion-icon>
				{{ loading ? "Asking" : "Ask" }}
			</ion-button>
		</div>
	</ion-toolbar>
</ion-footer>
